module.exports = __webpack_public_path__ + "static/media/CAMGreenBlack.2a75c31f.png";